import DashboardLayout from "@/components/layouts/DashboardLayout"
import help from "public/animations/help.json"
import dynamic from "next/dynamic"

const Lottie = dynamic(() => import('react-lottie-player/dist/LottiePlayerLight'), { ssr: false })

export default function Custom404Page() {
  return (
    <DashboardLayout title="Not Found">
      <div
        className="d-flex flex-column w-75 h-[75dvh] mx-auto text-center justify-content-center align-items-center"
        style={{ maxWidth: 300 }}
      >
        <Lottie 
          animationData={help} 
          style={{ height: 150, width: 150 }} 
          loop
          play
        />
        <p style={{ fontSize: 24, fontWeight: 'bold' }}>
          404 | Page not found...
        </p>
        <div className="w-100 w-md-50 mt-4">
          <p>
            Whoops, the page you're looking for doesn't exist.
          </p>
        </div>
      </div>
    </DashboardLayout>
  )
}
